import { useState } from "react";
import { useMe } from "../api/army";
import { useChatChannel } from "../lib/useChatChannel";
import { ChatPanel } from "../components/ChatPanel";
import { ScreenBanner } from "../components/ScreenBanner";

type ChatTab = "server" | "alliance";

// Single chat surface with two channels: the server-wide (per-world) chat and
// the player's alliance chat. Each channel only polls while its tab is active.
export function ChatScreen() {
  const me = useMe();
  const myId = me.data?.id ?? "";
  const [tab, setTab] = useState<ChatTab>("server");

  const world = useChatChannel("/chat/world", tab === "server");
  const ally = useChatChannel("/alliance/chat", tab === "alliance");

  const ch = tab === "server" ? world : ally;
  const allianceGate = tab === "alliance" && !ally.isLoading && ally.inAlliance === false;

  return (
    <div className="flex h-full flex-col">
      <ScreenBanner kind="army" title="Чат" subtitle="Сервер и альянс" />

      <div className="grid grid-cols-2 gap-1 px-2 pt-2">
        <TabBtn active={tab === "server"} onClick={() => setTab("server")}>
          Сервер
        </TabBtn>
        <TabBtn active={tab === "alliance"} onClick={() => setTab("alliance")}>
          Альянс
        </TabBtn>
      </div>

      <div className="min-h-0 flex-1">
        {allianceGate ? (
          <div className="p-6 text-center text-sm text-tg-hint">
            Вступи в альянс, чтобы общаться в его чате.
          </div>
        ) : (
          <ChatPanel
            messages={ch.messages}
            myId={myId}
            isLoading={ch.isLoading}
            pending={ch.pending}
            onSend={ch.send}
            onLoadOlder={ch.loadOlder}
            loadingOlder={ch.loadingOlder}
            hasMore={ch.hasMore}
            emptyText={
              tab === "server"
                ? "В мире пока тихо. Поздоровайся первым."
                : "Пока тихо. Напиши первое сообщение."
            }
          />
        )}
      </div>
    </div>
  );
}

function TabBtn({
  active,
  onClick,
  children,
}: {
  active: boolean;
  onClick: () => void;
  children: React.ReactNode;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`rounded-lg py-2 text-sm ${
        active ? "bg-tg-button text-tg-buttonText" : "bg-tg-secondaryBg text-tg-hint"
      }`}
    >
      {children}
    </button>
  );
}
